import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../services/global.service';

@Component({
  selector: 'app-remove-patient-account',
  templateUrl: './remove-patient-account.component.html',
  styleUrls: ['./remove-patient-account.component.scss']
})
export class RemovePatientAccountComponent implements OnInit {

  checkValue: boolean = false;
  phoneNumber: any;

  constructor(private globalService: GlobalService) { }

  ngOnInit(): void {
  }

  onCheck(value: boolean): void {
    this.checkValue = value;
  }

  requestAccountRemoval(): void {
    console.log(this.checkValue, this.phoneNumber)
    if (this.phoneNumber?.toString().length == 10 && this.checkValue) {
      //api call

      let postData = {
        phoneNumber: `91${this.phoneNumber}`,
        userType: 'patient'
      }

      this.globalService.removeAccount(postData).subscribe((response:any) => {
        if (response) {
          console.log("Response", response);

          this.phoneNumber = null;
          
          alert(response.result);

        }
      }, (err:any) => {
        alert("Something went wrong, Please try again later");
        console.error(err)
      })
    }

  }

}
